import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from 'services/analyticsService'

const PageViewTracker = () => {
  const location = useLocation()

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`

    trackPageView({
      path,
      title: document.title,
      location: window.location.href,
    })
  }, [location])

  return null
}

export default PageViewTracker
